import { IonIcon, IonLabel } from '@ionic/react';
import { personOutline, chevronForwardOutline } from 'ionicons/icons';
import { FormattedMessage } from 'react-intl';
import { Modal } from '../globals/Modal';
import { ModalProfileEdit } from './ModalProfileEdit';

export const MyProfile = ({ houseName, user, update }) => {
  return user ? (
    <Modal
      content={
        <ModalProfileEdit houseName={houseName} user={user} update={update} />
      }
      ModalUrl={'/profile/edit'}
      backUrl={window.innerWidth > 768 ? '/news' : '/profile'}
      hideCloseBtn={window.innerWidth > 768}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <div className="flex w-8 h-8 mr-4 inset-4 justify-center items-center border border-transparent rounded-full text-white bg-primary">
            <IonIcon icon={personOutline} />
          </div>
          <IonLabel className="font-medium text-sm">
            <FormattedMessage id="My profile" />
          </IonLabel>
        </div>
        <IonIcon icon={chevronForwardOutline} />
      </div>
    </Modal>
  ) : (
    <></>
  );
};
